<template>
  <div class="esi-warning">
    <h3>
      <v-icon name="alert-triangle" />
      {{ $t('Are you sure you want to continue?') }}
    </h3>
    <div>
      <p>{{ description }}</p>
      <ul>
        <li>{{ $t('Device type') }}</li>
        <li>{{ $t('Device name when empty') }}</li>
        <li>{{ $t('Missing PDOs will be added') }}</li>
        <li>{{ $t('All PDOs will be sorted by index in ascending order') }}</li>
        <li>{{ $t('All PDOs and Entries without a name or group will have their name and group set') }}</li>
        <li>{{ $t('All Entries will have their type set') }}</li>
        <li>{{ $t('All Entries will have their bitLength set') }}</li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { $t } from '/@/i18n'
import { computed } from 'vue'

const props = defineProps<{
  plural?: boolean
}>()

const description = computed(() => {
  if (props.plural) {
    return $t('The following settings will be updated for all devices:')
  }

  return $t('The following settings will be updated:')
})
</script>

<style lang="postcss">
.esi-warning {
  margin-bottom: calc(-1 * var(--spacing-2));

  & h3 .v-icon {
    color: var(--red-500);
    margin-right: var(--spacing-1);
  }

  & div > p {
    color: var(--color-text-subdued);
    margin-block: var(--spacing-2);
  }

  & div > ul {
    list-style: disc;
    padding-left: var(--spacing-8);

    & li {
      color: var(--color-text-subdued);
      margin-block: var(--spacing-1);
    }
  }
}
</style>
